import {
  BrandedSearchRateOverTimeAdvancedSearchResponse,
  BrandedSearchRateOverTimeDocument
} from 'src/components/Layout/Advertising/ConnectPageLayout/visualizations/AudiencesTab/BrandedSearchRate/types';
import _get from 'lodash/get';
import moment from 'moment';

/**
 * Parses advanced search response from Audiences - Branded Search Rate api request
 */
export const brandedSearchRateOverTimeAdvancedSearchParser = (
  response: BrandedSearchRateOverTimeAdvancedSearchResponse
) => {
  const brandedSearchRateOverTimeData: BrandedSearchRateOverTimeDocument[] = _get(
    response,
    ['aggregations', 'by_impressionDate.keyword'],
    []
  );
  return brandedSearchRateOverTimeData;
};

interface BuildRequestForBrandedSearchRateOverTimeParameters {
  startDayId: string | number;
  endDayId: string | number;
  retailerId?: string | number;
}

export const buildRequestForBrandedSearchRateOverTime = ({
  startDayId,
  endDayId,
  retailerId = 1
}: BuildRequestForBrandedSearchRateOverTimeParameters) => {
  return [
    {
      name: 'branded_search_rate_over_time',
      id: 'branded_search_rate_over_time',
      pageNumber: 1,
      pageSize: 1000,
      doAggregation: true,
      returnDocuments: false,
      conditions: {
        condition: 'must',
        termFilters: [
          {
            fieldName: 'periodStartDate',
            condition: 'should',
            values: [startDayId]
          },
          {
            fieldName: 'periodEndDate',
            condition: 'should',
            values: [endDayId]
          },
          {
            fieldName: 'retailerId',
            condition: 'should',
            values: [retailerId]
          }
        ],
        computeFilters: []
      },
      searchBy: 'parent',
      aggregations: [
        {
          aggregationFields: [
            {
              aggregateByFieldName: 'beaconClientId',
              function: 'sum',
              canBeExported: true
            },
            {
              aggregateByFieldName: 'impressions',
              function: 'sum',
              canBeExported: true
            },
            {
              aggregateByFieldName: 'numberOfBrandedSearches',
              function: 'sum',
              canBeExported: true
            }
          ],
          groupByFieldName: 'impressionDate.keyword'
        }
      ],
      searchType: 'advertising-amc-audiences-branded-search-rate-over-time',
      processDocuments: false
    }
  ];
};

export const convertBrandedSearchRateOverTimeDataToCSV = ({ data, dateRange }) => {
  const headers = ['Date', `Branded Search Rate: ${dateRange}`].map((val) => `"${val}"`).join(',');

  const values = data.map((dataPoint) => {
    const date = moment.utc(dataPoint[0]).format('MMM D');
    const dataValue = dataPoint[1] / 100;
    return [`${date}`, `${dataValue}`].map((val) => `"${val}"`).join(',');
  });

  return `${headers}\n${values.join('\n')}`;
};
